import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z"
}), 'ViewColumn');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewColumn.js
// module id = 7080
// module chunks = 2